import { AuthService } from './../../services/auth.service';
import { CommonService } from './../../services/common.service';
import { Subject } from 'rxjs';
import { FileService } from './../../services/file.service';
import { ActivatedRoute } from '@angular/router';
import { PosReportViewModel, DebtorStockMovement } from './../../models/pos-report-view.model';
import { Component, OnInit, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { ReportingService } from '../../services/reporting.service';
import { NgProgress } from 'ngx-progressbar';
import { Sort } from '@angular/material/sort';
import { TablefilterMultiplePipe } from '../../shared/pipes/tablefilter-multiple.pipe';
import { CurrentUserModel } from '../../models/account-ledger.model';
import { NgProgressService } from '../../services/ngProgress.service';
import { takeUntil } from 'rxjs/operators';

declare var $: any;

@Component({
  selector: 'app-sell-through-reports',
  templateUrl: './sell-through-reports.component.html',
  styleUrls: ['./sell-through-reports.component.css']
})
export class SellThroughReportsComponent implements OnInit, OnDestroy {

  title = 'Sell Through Reports';
  fromDate: NgbDate;
  toDate: NgbDate;
  strDateFrom = '';
  strDateTo = '';
  searchField = '';
  accountId = '';
  loadContent = false;
  searchFilter: string;
  filterResultArr: any;
  hasEmptyFilterResult: boolean = false;

  posReports: DebtorStockMovement[] = [];
  sortedData: DebtorStockMovement[] = [];
  reportData: DebtorStockMovement[] = [];

  //export excel
  url: string;

  ngUnsubscribe: Subject<void> = new Subject<void>();

  @ViewChild('entry', { read: ViewContainerRef })
  entry: ViewContainerRef;

  constructor(
    private router: Router,
    private activatedRouter: ActivatedRoute,
    private calendar: NgbCalendar,
    private reportingService: ReportingService,
    private fileService: FileService,
    private commonService: CommonService,
    private authService: AuthService,
    public ngProgress: NgProgressService
  ) { }


  sortData(sort: Sort) {
    let data = this.posReports.slice();

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'orderNumber': return compare(a.orderNumber.toLowerCase(), b.orderNumber.toLowerCase(), isAsc);
        case 'stockCode': return compare(a.stockCode.toLowerCase(), b.stockCode.toLowerCase(), isAsc);
        case 'stockDescription': return compare(a.stockDescription.toLowerCase(), b.stockDescription.toLowerCase(), isAsc);
        case 'invoiceDate': return compare(a.invoiceDate.toLowerCase(), b.invoiceDate.toLowerCase(), isAsc);
        case 'brand': return compare(a.brand.toLowerCase(), b.brand.toLowerCase(), isAsc);
        case 'transQty': return compare(parseInt(a.transQty), parseInt(b.transQty), isAsc);
        case 'serialNumber': return compare(a.serialNumber.toLowerCase(), b.serialNumber.toLowerCase(), isAsc);
        case 'invoiceNumber': return compare(a.invoiceNumber.toLowerCase(), b.invoiceNumber.toLowerCase(), isAsc);
        case 'unitPrice': return compare(parseFloat(a.unitPrice), parseFloat(b.unitPrice), isAsc);
        case 'linePrice': return compare(parseFloat(a.linePrice), parseFloat(b.linePrice), isAsc);
        default: return 0;
      }
    });
  }

  ngOnInit() {
    this.ngProgress.start();

    this.fromDate = this.calendar.getNext(this.calendar.getToday(), 'd', -14);
    this.toDate = this.calendar.getToday();

    this.loadContent = false;

    this.authService.getLoginInfo()
    .subscribe((res: CurrentUserModel) => {
      this.accountId = res.accountId;
    }, 
    (error: any) => {
      console.info(error);
    });

    this.getPosReports();

    this.ngProgress.done();
  }

  convertDateFormat(): void {
    this.strDateFrom = this.fromDate.day + '/' + this.fromDate.month + '/' + this.fromDate.year;
    this.strDateTo = this.toDate.day + '/' + this.toDate.month + '/' + this.toDate.year;

  }

  getPosReports() {
    this.convertDateFormat();
    this.reportingService.getPosReport(this.strDateFrom, this.strDateTo).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value: PosReportViewModel) => {

        this.posReports = value.debtorStockMovement;
        this.sortedData = this.posReports.slice();


      },
        (error: any) => {
          this.ngProgress.done();
          console.info(error);
        });
  }

  searchReports() {
    const isValid = this.validateDayRanges('btnSearch');

    if (!isValid) return;

    this.loadContent = false;

    this.getPosReports();

    this.searchFilter = "";
  }

  downloadReports(): void {
    const isValid = this.validateDayRanges('btnDownload');

    if (!isValid) return;

    //this.loadContent = false;

    //$('#btnDownload').showValidator('Usage data will be downloaded shortly', 'success', 'right');
    this.commonService.implementToast('Report will be downloaded shortly', 'Info');
    this.exportPosReport();

  }
  copyToClipboard(item: any): void {
    let listener = (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', (item));
      e.preventDefault();
    };

    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);
  }
  
  copySellThroughReportLink() {
    this.reportingService.copySellThroughReportLink().subscribe((res: string) => {
      if (res) {
        const downloadURL = window.location.origin + res;
        // console.log(downloadURL);
        this.copyToClipboard(downloadURL);
        this.commonService.implementToast("Sell Through download link copied to clipboard successfully", "Success");
      }
    },
      (error: any) => {
        console.error(error);
        this.commonService.implementToast("Get Datafeeds CSV download url failed", "Error");
      });
  }

  exportPosReport(): void {
    this.ngProgress.start();
    this.convertDateFormat();

    this.reportingService.exportPosReport(this.strDateFrom, this.strDateTo).pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((data: any) => {
        
        const fileName = `DD_POSREPORT_${this.accountId}_${this.strDateFrom}_To_${this.strDateTo}.xlsx`;

        this.fileService.saveAsExcelFile(data, fileName);
        this.ngProgress.done();
        this.commonService.implementToast('Report has been downloaded successfully', 'Success');
      },
        (error: any) => {
          console.info(error),
            this.ngProgress.done();
        });
  }


  validateDayRanges(btnName: string): boolean {
    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
    const utcFrom = Date.UTC(this.fromDate.year, this.fromDate.month, this.fromDate.day);
    const utcTo = Date.UTC(this.toDate.year, this.toDate.month, this.toDate.day);

    const days = Math.floor((utcTo - utcFrom) / _MS_PER_DAY);

    if (days > 90) {
      $('#' + btnName).showValidator('Report date range can be maximum of 90 days', 'error', 'right');
      return false;
    } else if (days < 1) {
      $('#' + btnName).showValidator('Invalid date range selected', 'error', 'right');
      return false;
    }

    return true;
  }

  onLoading(currentLoadingStatus: boolean) {

    this.loadContent = !currentLoadingStatus;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  close() {

    this.router.navigateByUrl('/reporting');
  }




  // filterCartItems(): void {
  //   if (this.searchFilter) {
  //     const searchFiled = this.searchFilter.toLowerCase();
  //     this.sortedData = this.posReports.filter(x => x.stockDescription.toLowerCase().includes(searchFiled)
  //       || x.stockCode.toLowerCase().includes(searchFiled) || x.serialNumber.toLowerCase().includes(searchFiled)
  //       || x.brand.toLowerCase().includes(searchFiled) || x.invoiceNumber.toLowerCase().includes(searchFiled)
  //       || x.invoiceDate.toLowerCase().includes(searchFiled)
  //       || x.transQty.toLowerCase().includes(searchFiled) || x.unitPrice.toLowerCase().includes(searchFiled)
  //       || x.linePrice.toLowerCase().includes(searchFiled))
  //     if (this.sortedData.length === 0) {
  //       this.hasEmptyFilterResult = true;
  //     }
  //     console.log(this.posReports)
  //     console.log(this.sortedData);
  //   }
  //   else {
  //     this.sortedData = this.posReports;
  //     this.hasEmptyFilterResult = false;
  //   }
  // }

  onChange() {
    this.filterResultArr = new TablefilterMultiplePipe().transform(this.sortedData, ['stockDescription', 'invoiceNumber', 'invoiceDate', 'stockCode', 'serialNumber'], this.searchField);
    if (this.filterResultArr.length === 0 && this.searchField !=='') {
      this.hasEmptyFilterResult = true;

    } else {
      this.hasEmptyFilterResult = false;
    }
  }

  filterReset() {
    this.searchField = "";
    this.hasEmptyFilterResult = false;
    this.sortedData = this.posReports;
  }

}


function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

